import React from 'react';
import FeatureTile from '../FeatureTile';
import { useTileData } from '../../../hooks/useTileData';
import { getBookingKpis } from '../../../api';
import { fmtCurrency, fmtNumber } from '../../shared/format';

// conversion_rate is already a percent (e.g. 3.74) not a fraction.
const pct = (v) => (v == null ? '—' : `${Number(v).toFixed(2)}%`);

const Icon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" aria-hidden>
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
  </svg>
);

export default function BookingsTile({ clientId, rangeStart, rangeEnd }) {
  const { data, loading, error } = useTileData(
    async () => {
      const resp = await getBookingKpis(clientId, rangeStart, rangeEnd);
      return resp?.data ?? null;
    },
    [clientId, rangeStart, rangeEnd],
    Boolean(clientId && rangeStart && rangeEnd),
  );

  const cur = data?.current;
  const primary = cur ? {
    value: fmtNumber(cur.total_bookings ?? 0),
    label: 'Total bookings',
    subtitle: `${fmtNumber(cur.total_sessions ?? 0)} sessions`,
  } : null;
  const secondary = cur ? [
    { value: pct(cur.conversion_rate), label: 'Conv. rate' },
    { value: fmtCurrency(cur.avg_booking_value ?? 0), label: 'Avg value' },
  ] : [];

  return (
    <FeatureTile
      title="Booking Intelligence"
      icon={<Icon />}
      color="blue"
      primary={primary}
      secondary={secondary}
      ctaLabel="Open"
      ctaTo="/bookings"
      loading={loading}
      error={error}
    />
  );
}
